import { useEffect, useState } from "react";
import { api } from "../lib/api";
import type { AuditLogEntry } from "../lib/types";

export default function AuditLog() {
  const [logs, setLogs] = useState<AuditLogEntry[] | null>(null);

  useEffect(() => {
    api<{ logs: AuditLogEntry[] }>("/audit").then((res) => setLogs(res.logs));
  }, []);

  return (
    <div>
      <div className="topbar">
        <div>
          <h1 className="page-title">Audit Log</h1>
          <div className="page-subtitle">Login attempts, employee changes, and pass/QR generation</div>
        </div>
      </div>

      <div className="card">
        {!logs ? (
          <div className="empty-state">Loading…</div>
        ) : logs.length === 0 ? (
          <div className="empty-state">No activity yet.</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>When</th>
                <th>Admin</th>
                <th>Action</th>
                <th>Target</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id}>
                  <td>{new Date(l.createdAt).toLocaleString()}</td>
                  <td>{l.admin?.username ?? "—"}</td>
                  <td>{l.action}</td>
                  <td>{l.targetType ? `${l.targetType}:${l.targetId?.slice(0, 8)}` : "—"}</td>
                  <td className="muted">{l.ipAddress ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
